import { useEffect, useState } from 'react';
import { locationService } from '../services/locationService';

export interface UserLocation {
  lat: number;
  lng: number;
}

/**
 * Hook ligero para obtener la ubicación actual del usuario sin tracking
 * continuo. Una sola lectura puntual al montar el componente.
 *
 * Usa expo-location nativo — no requiere Google Maps API. Si el usuario
 * niega el permiso o no responde, devuelve `null` (todas las pantallas
 * deben tener fallback gracioso).
 */
export function useUserLocation(): UserLocation | null {
  const [location, setLocation] = useState<UserLocation | null>(null);

  useEffect(() => {
    let cancelled = false;
    locationService
      .getCurrentLocation()
      .then((pos: any) => {
        if (cancelled) return;
        if (pos?.coords) {
          setLocation({
            lat: pos.coords.latitude,
            lng: pos.coords.longitude,
          });
        }
      })
      .catch(() => {
        // silent — null fallback
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return location;
}
